//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import VueScroller from 'vue-scroller'
Vue.use(VueScroller)

export default {
  name: 'scroll-list',
  props: {
    marginTop: {
      type: String,
      default: '0'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    loadurl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      noDate: false, //判断是否加载
      noDataText: '没有更多数据了',
      list: [],
      data: {
        curIndex: 1,
        pageSize: 20,
      }
    }
  },
  mounted() {
    //this.reqData();
  },
  methods: {
    // 下拉刷新
    refresh() {
      let _this = this;
      _this.$refs.myscroller.finishInfinite(false)
      _this.data.curIndex = 1; //重置页数刷新每次页数都是第一页
      _this.noDate = false;
      _this.list = [];
      _this.$emit('refresh', _this.list);
      _this.reqData();
    },
    // 上拉加载
    infinite(done) {
      let _this = this;
      setTimeout(() => {
        if (_this.noDate) {
          _this.$refs.myscroller.finishInfinite(true); //finishInfinite函数为scroller实例的方法，当参数为false时，上拉获取数据可以重新调用。当参数为true，上拉获取数据回调函数停止使用,下拉下部不再显示loading，会显示‘’暂无更多数据
        } else {
          _this.reqData(done);
          _this.data.curIndex++;
        }
      }, 1000);
    },
    //获取列表
    reqData(done) {
      let _this = this;
      let url = _this.loadurl || this.$parent.loadurl;
      let param = _this.$parent.params;
      let postData = Object.assign({}, _this.data, param);
      _this.$post(url, postData).then((res) => {
        //停止下拉刷新
        _this.$refs.myscroller.finishPullToRefresh();
        let listData = res || [];
        if (listData.length < postData.pageSize) {
          _this.noDate = true;
        } else {
          _this.noDate = false;
        }
        // 判断是下拉刷新还是上拉加载
        if (postData.curIndex == 1) {
          _this.list = listData;
        } else {
          _this.list = _this.list.concat(listData);
        }
        if (typeof(done) == "function") {
          done();
        }
        _this.$emit('refresh', _this.list);
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ScrollList.vue